import dayjs from "dayjs";

export const getInitials = (fullName: string) => {
  if (!fullName) return "";
  const words = fullName.trim().split(" ");
  return words
    .slice(0, 2)
    .map((word) => word[0].toUpperCase())
    .join("");
};

export const formatNumber = (value: number | string) => {
  if (!value) return "0";

  return new Intl.NumberFormat("en-US").format(Number(value));
};

/**
 * Formats a money amount. Unlike formatNumber, this caps the fraction digits — the revenue endpoints
 * return decimals, and a bare Intl.NumberFormat would render 12.499 as "12.499".
 * Whole amounts stay whole ("10"), fractional ones get exactly two places ("12.50").
 */
export const formatCurrencyAmount = (value: number | string) => {
  const amount = Number(value);

  if (!amount || Number.isNaN(amount)) return "0";

  const hasFraction = !Number.isInteger(amount);
  return new Intl.NumberFormat("en-US", {
    minimumFractionDigits: hasFraction ? 2 : 0,
    maximumFractionDigits: 2,
  }).format(amount);
};

/**
 * Formats an API date string for display, returning "-" for missing or unparseable values.
 * Guard the falsy case explicitly: dayjs(undefined) is today and dayjs(false) is the Unix epoch,
 * so passing a raw value straight to dayjs() invents a date instead of showing nothing.
 */
export const formatDate = (
  value?: string | null,
  format = "MMM DD, YYYY",
) => {
  if (!value) {
    return "-";
  }

  const parsedDate = dayjs(value);
  return parsedDate.isValid() ? parsedDate.format(format) : "-";
};

export const formatStatus = (status?: string | null) => {
  if (!status) return "";
  return status
    .toLowerCase()
    .replace(/_/g, " ")
    // .replace(/\b\w/g, (c) => c.toUpperCase());
};
